import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getClient } from '@chegg/rio-sdk-web';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
import { Step } from '../../components/webMfa/WebMfa.types';
export function getRioClient() {
  return getClient();
}
export function sendRioEvent(_x, _x2) {
  return _sendRioEvent.apply(this, arguments);
}
function _sendRioEvent() {
  _sendRioEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, data) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return getRioClient().sendEvent({
            type: type,
            data: data,
            eventVersion: 3
          });
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
            type: type,
            data: data,
            error: _context.t0
          }));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _sendRioEvent.apply(this, arguments);
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}
export function notificationsRioEvent(data) {
  return sendRioEvent('clickstream_notifications', data);
}
export function interactionRioEvent(data) {
  return sendRioEvent('clickstream_interaction', data);
}
export function successRioEvent(data) {
  return sendRioEvent('clickstream_success', data);
}
export function clickstreamViewEvent(step, authProvider) {
  if (step === Step.SendEmail) {
    updateRioState({
      view: {
        view_name: authProvider ? "mfa hard login modal - social ".concat(authProvider) : 'mfa hard login modal'
      }
    });
  }
  if (step === Step.ValidateCode) {
    updateRioState({
      view: {
        view_name: 'mfa enter code modal'
      }
    });
  }
  return sendRioEvent('clickstream_view', {});
}